import Vue from 'vue'
import CamptracService from '@/services/CamptracService.js'
export const namespaced = true

export const state = {
  isAddingCardBookingIds: [], // kan innehålla samma booking id flera gånger, om man lägger till flera kort på samma booking innan tidigare requests avslutats
  isRemovingCardUids: [],
  recentlyScannedUids: [],
  activeCamptracCards: [],
  lastCardUpdateAt: 0 // Detta är en timestamp från server, när senast ändring i korten gjordes, för att kunna hantera parallella requests som kan komma tillbaka i en annan ordningsföljd
}

export const mutations = {
  SET_IS_ADDING_CARD_BOOKING_IDS (state, { bookingId, val }) {
    if (val) {
      state.isAddingCardBookingIds.push(bookingId)
    } else {
      const i = state.isAddingCardBookingIds.findIndex(id => id === bookingId)
      state.isAddingCardBookingIds.splice(i, 1)
    }
  },
  SET_IS_REMOVING_CARD_UIDS (state, { val, cardUid }) {
    if (val) {
      const i = state.isRemovingCardUids.findIndex(id => id === cardUid)
      if (i < 0) {
        state.isRemovingCardUids.push(cardUid)
      }
    } else {
      const i = state.isRemovingCardUids.findIndex(id => id === cardUid)
      state.isRemovingCardUids.splice(i, 1)
    }
  },
  ADD_RECENTLY_SCANNED_UID (state, val) {
    state.recentlyScannedUids.push(val)
    setTimeout(() => {
      const i = state.recentlyScannedUids.findIndex(uid => uid === val)
      if (i >= 0) {
        state.recentlyScannedUids.splice(i, 1)
      }
    }, 4000)
  },
  SET_ACTIVE_CARDS (state, val) {
    state.activeCamptracCards = val
  },
  ADD_CARD (state, camptracCard) {
    const existingCard = state.activeCamptracCards.find(card => card.card_uid === camptracCard.card_uid)
    if (existingCard) {
      // Uppdaterar kortet lokalt, ifall det redan finns i activeCamptracCards
      existingCard.booking_id = camptracCard.booking_id
    } else {
      state.activeCamptracCards.push(camptracCard)
    }
  },
  REMOVE_CARD (state, cardUid) {
    // Behåller kortet lokalt men utan booking id
    const camptracCard = state.activeCamptracCards.find(card => card.card_uid === cardUid)
    camptracCard.booking_id = null
  },
  SET_LAST_CARD_UPDATE_AT (state, val) {
    state.lastCardUpdateAt = val
  }
}

export const actions = {
  addCard ({ state, commit }, { input, param }) {
    const booking = param
    const bookingId = booking.id
    const cardUid = input

    commit('ADD_RECENTLY_SCANNED_UID', cardUid)
    if (booking.camptrac_cards) {
      const existingCard = booking.camptrac_cards.find(c => c.card_uid === cardUid)
      if (existingCard) {
        // Lägger inte till kortet igen om det redan finns i camptrac_cards
        return false
      }
    }

    commit('SET_IS_ADDING_CARD_BOOKING_IDS', { bookingId, val: true })
    return CamptracService.addCard({ bookingId, cardUid })
      .then(({ data }) => {
        if (data.status === 'success' && data.data.timestamp > state.lastCardUpdateAt) {
          commit('SET_LAST_CARD_UPDATE_AT', data.data.timestamp)
          Vue.set(booking, 'camptrac_cards', data.data.camptrac_cards)
        }
      })
      .finally(() => {
        commit('SET_IS_ADDING_CARD_BOOKING_IDS', { bookingId, val: false })
      })
  },
  removeCard ({ state, commit }, { cardUid, booking }) {
    const bookingId = booking.id
    commit('SET_IS_REMOVING_CARD_UIDS', { cardUid, val: true })
    return CamptracService.removeCard({ bookingId, cardUid })
      .then(({ data }) => {
        if (data.status === 'success' && data.data.timestamp > state.lastCardUpdateAt) {
          commit('SET_LAST_CARD_UPDATE_AT', data.data.timestamp)
          Vue.set(booking, 'camptrac_cards', data.data.camptrac_cards)
        }
      })
      .finally(() => {
        commit('SET_IS_REMOVING_CARD_UIDS', { cardUid, val: false })
      })
  },
  fetchCards ({ commit, rootState }) {
    if (rootState.workstation?.access_driver !== 'camptrac') {
      return new Promise(resolve => resolve())
    }
    commit('SET_ACTIVE_CARDS', [])
    return CamptracService.fetchCards()
      .then(({ data }) => {
        if (data.status === 'success') {
          commit('SET_ACTIVE_CARDS', data.data.cards)
        }
      })
      .finally(() => {
        window.channel.stopListening('AddedCamptracCard').listen('AddedCamptracCard', function (data) {
          commit('ADD_CARD', data.camptracCard)
        })
        window.channel.stopListening('RemovedCamptracCard').listen('RemovedCamptracCard', function (data) {
          commit('REMOVE_CARD', data.card_uid)
        })
      })
  }
}
